import { parseCurrency } from '@helper/parseCurrency'

export const parsePlanOtbDataFooter = (data: any[]): any[] => {
  const res = []

  let estoqueInicial = 0
  let recebimentosProgramados = 0
  let otbPlanejamento = 0
  let vendasProjetadasPlanoDeCompra = 0
  let estoqueFinal = 0
  let estoqueFinalAjustado = 0

  data.forEach(obj => {
    return (estoqueInicial += Number(
      obj.estoqueInicialAjustado > 0
        ? obj.estoqueInicialAjustado
        : obj.estoqueInicial
    ))
  })
  data.forEach(obj => {
    return (recebimentosProgramados += Number(obj.aReceber))
  })
  data.forEach(obj => {
    return (otbPlanejamento += Number(obj.vendaProjetada))
  })
  data.forEach(obj => {
    return (vendasProjetadasPlanoDeCompra += Number(obj.compraProjetada))
  })
  data.forEach(obj => {
    return (estoqueFinal += Number(obj.estoqueFinal))
  })
  data.forEach(obj => {
    return (estoqueFinalAjustado += Number(obj.estoqueFinalAjustado))
  })

  res.push({
    'empresa-periodo-id': 'Total:',
    'empresa-codigo-id': '',
    'categoria-compacta-codigo-id': '',
    'categoria-compacta-descricao-id': '',
    'categoria-codigo-id': '',
    'categoria-descricao-id': '',
    'indicadores-estoque-inicial-id': parseCurrency({
      value: estoqueInicial,
      country: 'pt-br'
    }),
    'indicadores-a-receber-id': parseCurrency({
      value: recebimentosProgramados,
      country: 'pt-br'
    }),

    'indicadores-planej-projet-id': parseCurrency({
      value: otbPlanejamento,
      country: 'pt-br'
    }),
    'indicadores-compra-projet-id': parseCurrency({
      value: vendasProjetadasPlanoDeCompra,
      country: 'pt-br'
    }),
    'indicadores-estoque-final-id': parseCurrency({
      value: estoqueFinal,
      country: 'pt-br'
    }),
    'indicadores-estoque-final-ajust-id': parseCurrency({
      value: estoqueFinalAjustado,
      country: 'pt-br'
    })
  })

  return res
}
